<template>
    <b-modal 
        size="lg" 
        no-close-on-backdrop 
        centered
        hide-footer
        title="Dados do Limite"
        v-model="open"
    >
        <div class="d-block text-center">
            <h4>Preencha abaixo o  limite e a data de vencimento.</h4>
        </div>

        <div class="d-block text-center mt-5">
            <h5>Cliente selecionado: <b-badge class="fs-16" variant="warning">{{ client }}</b-badge></h5>
        </div>

        <b-row class="container mt-4">
            <b-col cols="6">
                <label>Limite de crédito</label>
                <div class="input-group mb-3">
                    <div class="input-group-append">
                        <span class="input-group-text" id="value-total">R$</span>
                    </div>
                    <input 
                        v-model="limit" 
                        type="number"  
                        class="form-control" 
                        placeholder="Digite o valor" 
                        aria-label="Recipient's username" 
                        aria-describedby="value-total"
                    >
                </div>
            </b-col>
            <b-col  cols="6">
                <label>Dia vencimento</label>
                <v-select
                    class="select"
                    v-model="due"
                    :options="day"
                >
                <div slot="no-options">
                    Desculpe, selecione um numero de 1 até 28!
                </div>
                </v-select>
            </b-col>
        </b-row>

        <div class="container d-flex justify-content-end mt-2">
            <button 
                class="btn btn-success btn-width" 
                @click="addClient()"
            >
            Salvar
            </button>
        </div>
    </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';

export default {
    name:'ValueClient',
    emits:['saveClientWallet'],
    mixins: [makeToast],

    data() {
        return  {
            open: false,
            loading: false,
            client:'',
            limit:'',
            due: '',
            day:[],
        }
    },

    methods: {
        toggleOpen(client = '') {
            this.open = !this.open;
            this.client = client.nameClient;
            this.daysDue();
        },
        daysDue(){
            for (let index = 0; index < 28; index++ ) {
                this.day[index] = index +1;        
            }
        },
        addClient(){
            if(!this.limit){
                this.makeToast(
                'Erro',
                'Favor colocar o valor do limite!',
                'danger'
                );
                return
            }

            if(!this.due){
                this.makeToast(
                'Erro',
                'Favor colocar o dia do vencimento!',
                'danger'
                );
                return
            }
            let data = {};
            data = {
                limit: this.limit,
                due: this.due
            }
            this.open = !this.open;
            this.$emit('saveClientWallet', data);
        }
    }
}
</script>

<style>
.btn-width {
    width: 200px;
}
</style>